(() => {
  const normalize = value => String(value || '').trim().toLowerCase();
  const genderOf = value => {
    const text = normalize(value);
    if (/unisex|унисекс/.test(text)) return null;
    const women = /дамск|женск|жена|\b(women|womens|woman|female|ladies|donna|femminile)\b/.test(text);
    const men = /мъж|\b(men|mens|man|male|uomo|maschile)\b/.test(text);
    return women === men ? null : women ? 'women' : 'men';
  };
  const productGender = (() => {
    const element = document.querySelector('[data-sxt-product-audience]');
    if (!element) return null;
    try {
      const data = JSON.parse(element.textContent);
      const field = normalize(data.gender);
      if (/unisex|унисекс/.test(field)) return null;
      const explicit = field === 'f' ? 'women' : field === 'm' ? 'men' : genderOf(field);
      return explicit || genderOf((data.tags || []).join(' ')) || genderOf((data.collections || []).join(' '));
    } catch { return null; }
  })();
  const params = new URLSearchParams(location.search);
  const explicitGender = ['women', 'men'].includes(params.get('sxt_gender')) ? params.get('sxt_gender') : null;
  const collectionGender = genderOf(document.querySelector('.sxt-collection-guide h1')?.textContent);
  const savedGender = () => {
    try {
      const value = localStorage.getItem('sxt-home-gender');
      return ['women', 'men'].includes(value) ? value : null;
    } catch { return null; }
  };
  const rememberGender = gender => {
    try { localStorage.setItem('sxt-home-gender', gender); } catch {}
  };
  if (productGender || explicitGender || collectionGender) rememberGender(productGender || explicitGender || collectionGender);
  const navGender = () => (document.body.classList.contains('template-index') ? document.documentElement.dataset.sxtHomeGender : null) || productGender || explicitGender || collectionGender || document.documentElement.dataset.sxtHomeGender || savedGender() || 'women';
  const syncNavigation = () => {
    const gender = navGender();
    document.querySelectorAll('[data-sxt-product-gender-crumb]').forEach(item => {
      const link = item.querySelector('a');
      const home = item.closest('nav').querySelector('[data-sxt-breadcrumb-home]');
      if (!link || !home) return;
      const url = new URL(home.href);
      url.searchParams.set('sxt_gender', gender);
      link.href = url.href;
      link.textContent = document.documentElement.lang.startsWith('en') ? (gender === 'men' ? 'Men' : 'Women') : (gender === 'men' ? 'Мъж' : 'Жена');
      item.hidden = false;
    });
    document.querySelectorAll('[data-sxt-nav-audience]').forEach(nav => { nav.hidden = nav.dataset.sxtNavAudience !== gender; });
    document.querySelectorAll('.sxt-header-gender a').forEach(link => {
      link.setAttribute('aria-current', String(new URL(link.href).searchParams.get('sxt_gender') === gender));
    });
  };
  syncNavigation();
  new MutationObserver(syncNavigation).observe(document.documentElement, { attributes: true, attributeFilter: ['data-sxt-home-gender'] });
  // Preserve the storefront choice through category and product navigation.
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.origin);
    const isProduct = url.pathname.includes('/products/');
    if (url.origin !== location.origin || (!isProduct && !url.pathname.includes('/collections/'))) return;
    if (!isProduct && !link.closest('[data-sxt-audience], [data-sxt-nav-audience]')) return;
    const gender = navGender();
    rememberGender(gender);
    url.searchParams.set('sxt_gender', gender);
    link.href = url.href;
  });
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add('sxt-reveal');
    observer.unobserve(entry.target);
  }), { threshold: .08 });
  const observeSections = () => document.querySelectorAll('#MainContent > .shopify-section:not(:has(.banner)):not(:has([data-sxt-audience][hidden])), .sxt-complete-look').forEach(section => {
    if (!section.dataset.sxtRevealBound) { section.dataset.sxtRevealBound = 'true'; observer.observe(section); }
  });
  observeSections();
  document.addEventListener('shopify:section:load', observeSections);
  new MutationObserver(observeSections).observe(document.documentElement, { attributes: true, attributeFilter: ['data-sxt-home-gender'] });
})();
